import React, { useState } from 'react';
import * as Sentry from '@sentry/react';
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faExclamationTriangle, faTrash } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { SellerGroupQuery, useDeleteSellerGroupMutation } from '../../generated/graphql';

interface Props { slug: string; sellerGroup: NonNullable<SellerGroupQuery['sellerGroup']> }

const ConfirmRemoveModal = ({ slug, sellerGroup: { _id, orders } }:Props) => {
  const [modal, setModal] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [deleteSellergroupMutation] = useDeleteSellerGroupMutation();
  const navigate = useNavigate();

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  const toggleModal = () => setModal(!modal);
  const [translate] = useTranslation();

  const deleteSellerGroup = () => {
    deleteSellergroupMutation({ variables: { _id } })
      .then(() => {
        navigate(`/${slug}`);
        toast(translate('COMPONENTS.CONFIRM_REMOVE_MODAL.DELETE_DATA_CONFIRMATION'), {
          type: toast.TYPE.SUCCESS,
        });
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.log(e);
        Sentry.captureException(e);
        // eslint-disable-next-line no-alert
        window.alert(e);
      })
      .finally(toggleModal);
  };

  return (
    <>
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle outline>
          <FontAwesomeIcon icon={faEllipsisV} />
        </DropdownToggle>
        <DropdownMenu end>
          <DropdownItem onClick={toggleModal}>
            <FontAwesomeIcon icon={faTrash} fixedWidth />
            {' '}
            {translate('COMPONENTS.CONFIRM_REMOVE_MODAL.DELETE_MY_DATA')}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>
          <FontAwesomeIcon icon={faExclamationTriangle} />
          {' '}
          {translate('COMMON.ATTENTION')}
        </ModalHeader>
        <ModalBody className="my-3">
          <p>{translate('COMPONENTS.CONFIRM_REMOVE_MODAL.REMOVE_YOURSELF')}</p>
          <p>{translate('COMPONENTS.CONFIRM_REMOVE_MODAL.PERSONAL_LINK_EXPIRE')}</p>
          <p>
            {orders?.length === 0
              ? null
              : translate('COMPONENTS.CONFIRM_REMOVE_MODAL.SCOREBOARD_NAME', { count: orders?.length })}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="link" onClick={deleteSellerGroup}>
            {translate('COMPONENTS.CONFIRM_REMOVE_MODAL.SURE_TO_DELETE_DATA')}
          </Button>
          {' '}
          <Button color="primary" onClick={toggleModal}>{translate('COMMON.CANCEL')}</Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ConfirmRemoveModal;
